import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HeaderService } from './header.service'
import { Observable } from 'rxjs/Observable';

import {IForma, IFormaPregunta, ITipificacionLog, IResultadosQuery, EQueryType, IResultado } from '../../common/forma';
import { IDBResponse } from '../../common/responses'

@Injectable()
export class FormasService {

    constructor(private $http: Http, private $header: HeaderService) { }
    
    getFormularios(): Observable<IForma[]> {
        return this.$http.get(this.$header.getApi() + '/formas', {headers: this.$header.getHeaders()})
            .map((res: Response) => res.json())
    }
    
    getPreguntasFormulario(id: string): Observable<IFormaPregunta[]> {
        return this.$http.get(this.$header.getApi() + '/forma/' + id, { headers: this.$header.getHeaders() })
            .map(res => res.json())
    }
    
    guardarFormulario(data: { update: boolean, frm: IForma }): Observable<IDBResponse> {
        let http$: Observable<Response>;
        
        if (data.update === undefined) { // Eliminar
            http$ = this.$http.delete(this.$header.getApi() + '/forma/' + data.frm.id, { headers: this.$header.getHeaders() });
        }
        else if (!!data.update) { // Actualizar
            http$ = this.$http.post(this.$header.getApi() + '/forma', data.frm, { headers: this.$header.getHeaders() });
        }
        else { // guardar
            http$ = this.$http.put(this.$header.getApi() + '/forma', data.frm, { headers: this.$header.getHeaders() });
        }
        
        return http$.map(res => res.json())
            .catch((err: Response) => Observable.throw(err.json()));
    }
    
    guardarLog(forma: ITipificacionLog[]): Observable<IDBResponse> {
        return this.$http.put(this.$header.getApi() + '/forma_log', forma, { headers: this.$header.getHeaders() })
            .map(res => res.json())
            .catch((err: Response) => Observable.throw(err.json()));
    }
    
    buscarResultados(query: IResultadosQuery): Observable<IResultado[]> {
        return this.$http.post(this.$header.getApi() + '/resultados_forma_log', query, { headers: this.$header.getHeaders() })
            .map(res => res.json() as IDBResponse)            
            .map(response => response.data as IResultado[])
            .catch((err: Response) => Observable.throw(err.json()));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_services/formas.service.ts